import "../scss/styles.scss";

import { Offcanvas, Modal } from 'bootstrap';
import { Swiper} from "swiper";
import { Pagination } from 'swiper/modules';
import { CountUp } from 'countup.js';

const swiperDisenoBachiller = new Swiper('.swiper-diseno-bachiller', {
    modules: [Pagination],
    speed: 500,
    spaceBetween: 10,
    slidesPerView: 2,
    slidesPerGroup: 2,
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    // },
    pagination: {
        el: '.swiper-pagination-diseno-bachiller',
        type: 'bullets',
        clickable: true
    },
    breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 3,
          spaceBetween: 30,
          slidesPerGroup: 3
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
          slidesPerGroup: 4
        }
      }
});

const swiperDisenoTecnicas = new Swiper('.swiper-diseno-tecnicas', {
    modules: [Pagination],
    speed: 500,
    spaceBetween: 10,
    slidesPerView: 2,
    slidesPerGroup: 2,
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    // },
    pagination: {
        el: '.swiper-pagination-diseno-tecnicas',
        type: 'bullets',
        clickable: true
    },
    breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 3,
          spaceBetween: 30,
          slidesPerGroup: 3
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
          slidesPerGroup: 4
        }
      }
});

const swiperComunicacionesBachiller = new Swiper('.swiper-comunicaciones-bachiller', {
    modules: [Pagination],
    speed: 500,
    spaceBetween: 10,
    slidesPerView: 2,
    slidesPerGroup: 2,
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    // },
    pagination: {
        el: '.swiper-pagination-comunicaciones-bachiller',
        type: 'bullets',
        clickable: true
    },
    breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 3,
          spaceBetween: 30,
          slidesPerGroup: 3
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
          slidesPerGroup: 4
        }
      }
});

const swiperComunicacionesTecnicas = new Swiper('.swiper-comunicaciones-tecnicas', {
    modules: [Pagination],
    speed: 500,
    spaceBetween: 10,
    slidesPerView: 2,
    slidesPerGroup: 2,
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    // },
    pagination: {
        el: '.swiper-pagination-comunicaciones-tecnicas',
        type: 'bullets',
        clickable: true
    },
    breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 3,
          spaceBetween: 30,
          slidesPerGroup: 3
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
          slidesPerGroup: 4
        }
      }
});

const swiperNegociosBachiller = new Swiper('.swiper-negocios-bachiller', {
    modules: [Pagination],
    speed: 500,
    spaceBetween: 10,
    slidesPerView: 2,
    slidesPerGroup: 2,
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    // },
    pagination: {
        el: '.swiper-pagination-negocios-bachiller',
        type: 'bullets',
        clickable: true
    },
    breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 3,
          spaceBetween: 30,
          slidesPerGroup: 3
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
          slidesPerGroup: 4
        }
      }
});

const swiperNegociosTecnicas = new Swiper('.swiper-negocios-tecnicas', {
    modules: [Pagination],
    speed: 500,
    spaceBetween: 10,
    slidesPerView: 2,
    slidesPerGroup: 2,
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    // },
    pagination: {
        el: '.swiper-pagination-negocios-tecnicas',
        type: 'bullets',
        clickable: true
    },
    breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 3,
          spaceBetween: 30,
          slidesPerGroup: 3
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
          slidesPerGroup: 4
        }
      }
});

const countUpEstudiantes = new CountUp('target-estudiantes', 10500, { 
    enableScrollSpy: true,
    duration: 4,
    prefix: '+',
});

const countUpEgresados = new CountUp('target-egresados', 11000, { 
    enableScrollSpy: true,
    duration: 3,
    prefix: '+',
});

const countUpDocentes = new CountUp('target-docentes', 550, { 
    enableScrollSpy: true,
    duration: 2,
    prefix: '+',
});

const countUpSatisfaccion = new CountUp('target-satisfaccion', 90, { 
    enableScrollSpy: true,
    duration: 2,
    prefix: '+',
    suffix: '%',
});

/**
 * CODE: Videomodal 
 */
let videoSrc;

// Add click event listener to all elements with class "video-btn"
document.querySelectorAll('.btn-video').forEach(button => {
	button.addEventListener('click', () => {
    	videoSrc = button.dataset.src;
    	console.log(videoSrc);
  	});
});

document.getElementById('videoSilvia').addEventListener('shown.bs.modal', () => {
	document.getElementById('video').src = videoSrc + "?autoplay=1&amp;modestbranding=0&amp;showinfo=0&amp;fullscreen";
});

document.getElementById('videoSilvia').addEventListener('hide.bs.modal', () => {
	document.getElementById('video').src = videoSrc;
});
